import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  startFreeTrial: {
    defaultMessage: 'Start Free Trial',
    description: 'Button text to start a free trial of a higher plan tier',
    id: 'aQ1xah',
  },
  trialStartSuccessTitle: {
    defaultMessage: 'Trial Activated',
    description: 'Title for success notification when a plan trial is successfully activated',
    id: 'bLyc9u',
  },
  trialStartSuccess: {
    defaultMessage:
      'You now have access to all features on our {planName} Plan, including new analytics dashboards, inventory, mobile picking, returns and exchanges, and more. Scale your business with these advanced tools.',
    description: 'Success notification message when a plan trial is successfully activated',
    id: 'tRmBly',
  },
  trialStartErrorTitle: {
    defaultMessage: 'Error Activating Trial',
    description: 'Title for error notification when a plan trial fails to activate',
    id: '9weRcQ',
  },
  trialStartError: {
    defaultMessage: 'Unable to start trial. Please try again later.',
    description: 'Error notification message when a plan trial fails to activate',
    id: 'qZ/1pS',
  },
  upgradeSubscription: {
    defaultMessage: 'Upgrade Subscription',
    description: 'Button text to upgrade to a higher plan tier without trial',
    id: 'vg3ZuW',
  },
});
